export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const setRegToken = (token) => ({
  type: "SET_REGTOKEN",
  payload: {
    token,
  },
});
export const setAdmindata = (admindata) => ({
  type: "SET_ADMIN_DATA",
  payload: {
    admindata,
  },
});
